// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banner":"GTFAuBtt9Eylzxhp_tO8","banner-inner":"apGmlmwNI8w7Ullps_zN","submit":"Oa8jCOH8w8OL7k87XSs8","text":"PDHi0f9BpvUzCnjhqw2A"};